import { CODES } from '../config/apiErrorCodes';
import { RollbarErrorTracking } from '../../Rollbar/RollbarErrorTracking';
import logger from '../../Loggly/Logger';
import { AES, enc } from 'crypto-js';
//import store here
import { store } from '../../Redux/_helpers/store';
import 'react-toastify/dist/ReactToastify.css';
import { successLoader, } from '../../Redux/_actions/loader.action';
import Cookies from 'cookies-js';
import { toast } from "react-toastify";
import { v4 as uuidv4 } from 'uuid';
toast.configure()
async function requestTimeout(ms, controller) {
    return new Promise(resolve => {
        setTimeout(function () {
            console.log('5 seconds done', controller)
            controller.abort();
        }, ms);
    });
}
// let isTokenAvailable ='';
// const refreshToken =  sessionStorage.getItem("isAuthenticated")
// if(refreshToken != null){
// const decrypted = AES.decrypt(refreshToken, 'itsEncrypted');
// const decryptedObject = decrypted.toString(enc.Utf8);
// const getRefreshToken = JSON.parse(decryptedObject)
//  isTokenAvailable = JSON.stringify(getRefreshToken);
// }
export const ApiCall = async (method = 'GET', link, body, headers, showToast = true, isUpload = false) => {
    const isTokenAvailable = await sessionStorage.getItem("Decrypted Token")
    const tokenDetails = JSON.parse(isTokenAvailable);
    const testAccess = Cookies.get('_msAL');
    let uuID = uuidv4();
    //true
    store.dispatch(successLoader(false));
    const controller = new AbortController();
    const signal = controller.signal;
    requestTimeout(25000, controller);
    let obj = {
        method: method,
        headers: {
            ...headers, Authorization: 'Bearer' + ` ${testAccess}`, 'x-cc-trace-id': uuID, "channel": 'web',
            "appVersion": 'v1.1.0'
        },
        signal: controller.signal
    };
    if (method == "PUT" || method == "POST" || method == "PATCH" || method == "DELETE") {
        if(!isUpload){ 
            body = JSON.stringify(body);
            body = body.split(':""')
            body = body.join(':null');
            body = JSON.parse(body);
        }
      

        obj.body = isUpload ? body : JSON.stringify(body)
    }
    console.log(body);
    return fetch(link, obj)
        .then((data) => {
            // false
            store.dispatch(successLoader(true));
            return data;
        })
        .then((data) => {
            if (data.status == '200') {
                return data.json().then(d => {
                    //replacing all nulls with empty string
                    d = JSON.stringify(d);
                    d = d.split('null')
                    d = d.join('""');
                    d = JSON.parse(d);
                    return d
                }).catch(err => "");
            }
            else if (data.status == '500') {
                let status = data.status;
                return data.json().then(d => { return { data: d, flag: status } });
            }
            throw { statusCode: data.status };
        })
        .then((data) => {
            return data;
        })
        .catch((err) => {
            // false
            store.dispatch(successLoader(true));
            if (err.statusCode) {
                let code = err.statusCode;
                err = Object.keys(CODES).includes("" + code) ? `${code}, ${CODES[code]}` : err;
            }
            let toastMessage = (err.name === 'AbortError') ? 'Request Timeout' : 'Something went wrong!';
            if (showToast) {
                toast(toastMessage, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } });
            }
            //  toast.show(
            //     toastMessage,
            //     ToastAndroid.SHORT,
            // );
            console.warn('inside catch', err);
            // client side logging using rollbar
            // logger.push({ err, link }); 
            // RollbarErrorTracking.logErrorInRollbar(err.response.data.message);
            return { errorMessage: err, flag: -1 }
        })
}
